import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

type TProps = {
  matches2: boolean;
  history: any;
};

export const ReturnButton: React.FC<TProps> = ({ matches2, history }) => {
  return (
    <div className='table-top-container-customer'>
      <div style={{ fontWeight: 'bold' }}>
        <Button
          style={{
            minWidth: 90,
            marginRight: 15,
            color: '#758283',
            backgroundColor: '#F5F5F5',
            marginBottom: !matches2 ? 10 : 0
          }}
          variant='contained'
          color='secondary'
          onClick={() => {
            //// 戻る先を判定する
            if (history.location.state.params || history.location.state.tabs) {
              if (history.location.state.previouspath === 'to_construction') {
                //工事一覧画面へ
                history.replace(
                  `/constructions_document/${history.location.state.rowId}/edit`,
                  history.location.state
                );
                console.log(history.location.state);
              } else {
                //請求書一覧へ
                history.push('/invoices', history.location.state);
              }
            } else {
              if (history.location.state?.currentPage) {
                history.push('/invoices', history.location.state);
              } else {
                history.goBack();
              }
            }
          }}
          startIcon={<ArrowBackIcon />}
        >
          戻る
        </Button>
      </div>
    </div>
  );
};
